import { render, staticRenderFns } from "./AsStampHistoryIndex.vue?vue&type=template&id=9e6a919e&scoped=true"
import script from "./AsStampHistoryIndex.vue?vue&type=script&lang=js"
export * from "./AsStampHistoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6a919e",
  null
  
)

export default component.exports